/**
 * What the command palette (⌘K) offers: every screen this person may open, the Learn pages and missions, and a few
 * actions. Built from the registries, so a new screen or mission shows up here with no other change.
 */
import { missionNumber, missionsInOrder } from '../learn/missions'
import type { Screen } from '../screens'
import type { Command, NavItem } from '../ui'

export function buildCommands(opts: {
  screens: Pick<Screen, 'path' | 'title' | 'description' | 'icon' | 'group'>[]
  /** Learn's pages; null for viewers. */
  learn: NavItem[] | null
  navigate: (to: string) => void
  /** Absent: no Sign out command (the demo). */
  signOut?: () => void
  /** The component board, in development only. */
  board: boolean
}): Command[] {
  const commands: Command[] = opts.screens.map((s) => ({
    id: `screen:${s.path}`,
    label: s.title,
    group: 'Operate',
    icon: s.icon,
    hint: s.path,
    keywords: `${s.description} ${s.group ?? ''}`,
    run: () => opts.navigate(s.path),
  }))
  if (opts.learn) {
    for (const item of opts.learn) {
      commands.push({ id: `learn:${item.to}`, label: item.label, group: 'Learn', icon: item.icon, run: () => opts.navigate(item.to) })
    }
    for (const m of missionsInOrder()) {
      commands.push({
        id: `mission:${m.id}`,
        label: `${missionNumber(m)} · ${m.title}`,
        group: 'Learn',
        icon: 'mission',
        keywords: `mission ${m.say}`,
        run: () => opts.navigate(`/learn/missions/${m.id}`),
      })
    }
  }
  if (opts.board) {
    commands.push({ id: 'board', label: 'Component board', group: 'Actions', icon: 'grid', hint: '/__ui', keywords: 'ui library', run: () => opts.navigate('/__ui') })
  }
  if (opts.signOut) commands.push({ id: 'signout', label: 'Sign out', group: 'Actions', icon: 'signout', keywords: 'log out', run: opts.signOut })
  return commands
}
